/* eslint-disable react/prop-types */
import { array, bool, number, string } from 'prop-types';
import React from 'react';
import { Icon, Text, Tooltip } from '@chaser/components';
import { adjustRate, calculateFee } from '../util';
import { formatDate } from '../../../util/time';
import style from './PricingTable.module.scss';
import useOrganisationUtils from '../../../hooks/useOrganisationUtils';

const Cell = ({ children, colSpan, weight, textAlign }) => (
  <td colSpan={colSpan} style={{ textAlign }}>
    <Text fontSize="xsmall" fontWeight={weight}>
      {children}
    </Text>
  </td>
);
const HeaderCell = ({ children, textAlign }) => (
  <th style={{ textAlign }}>
    <Text fontSize="xsmall" fontWeight="bold">
      {children}
    </Text>
  </th>
);

const RATE_PENDING_TOOLTIP = 'Please complete the customer details';

const PricingTable = ({ invoices, rate, countryCode, currency, isRateReady = false }) => {
  const { formatCurrency } = useOrganisationUtils();
  const countriesIncludingVat = ['GB'];
  const hasCalculatedRate = isRateReady && Number(rate) > 0;

  const renderRateOrPlaceholder = () => {
    if (hasCalculatedRate) {
      return (
        <>
          {adjustRate(rate)}% {countriesIncludingVat.includes(countryCode) && '+ VAT'}
        </>
      );
    }

    return (
      <Tooltip position="top" content={RATE_PENDING_TOOLTIP}>
        <Icon name="info" color="Mid Neutral 2" size={16} />
      </Tooltip>
    );
  };

  const renderFeeOrPlaceholder = amountDue => {
    if (hasCalculatedRate) {
      return formatCurrency(calculateFee(rate, amountDue), currency);
    }

    return (
      <Tooltip position="top" content={RATE_PENDING_TOOLTIP}>
        <Icon name="info" color="Mid Neutral 2" size={16} />
      </Tooltip>
    );
  };

  return (
    <table className={style.pricingTable}>
      <thead>
        <tr>
          <HeaderCell>Invoice no</HeaderCell>
          <HeaderCell>Due</HeaderCell>
          <HeaderCell>Outstanding</HeaderCell>
          <HeaderCell>Rate</HeaderCell>
          <HeaderCell textAlign="right">Fee</HeaderCell>
        </tr>
      </thead>
      <tbody>
        {invoices.map(({ InvoiceNumber, DueDate, AmountDue, CurrencyCode }) => (
          <tr key={InvoiceNumber}>
            <Cell>{InvoiceNumber}</Cell>
            <Cell>{formatDate(DueDate)}</Cell>
            <Cell>{formatCurrency(AmountDue, CurrencyCode)}</Cell>
            <Cell>{renderRateOrPlaceholder()}</Cell>
            <Cell textAlign="right">{renderFeeOrPlaceholder(AmountDue)}</Cell>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

PricingTable.propTypes = {
  invoices: array.isRequired,
  rate: number.isRequired,
  currency: string.isRequired,
  isRateReady: bool,
};

export default PricingTable;
